/* ============================================================
   KANIN CART DRAWER JS
   ============================================================ */

(function () {
  'use strict';

  const drawer     = document.getElementById('kcd-drawer');
  const overlay    = document.getElementById('kcd-overlay');
  const closeBtn   = document.getElementById('kcd-close');
  const itemsEl    = document.getElementById('kcd-items');
  const emptyEl    = document.getElementById('kcd-empty');
  const countEl    = document.getElementById('kcd-count');
  const subtotalEl = document.getElementById('kcd-subtotal');

  if (!drawer) return;

  /* ── Open / Close ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Wire cart triggers ── */
  function wireCartTriggers() {
    document.querySelectorAll('a[href="/cart"]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    const cartBtn = document.querySelector('.header__icon--cart, #cart-icon-bubble');
    if (cartBtn) {
      cartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    }
  }

  /* ── Format money ── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ── Fetch cart ── */
  function fetchCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function (err) { console.error('Cart fetch error', err); });
  }

  /* ── Render cart ── */
  function renderCart(cart) {
    // Update count
    countEl.textContent = cart.item_count;

    // Update Dawn's header count
    document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    // Subtotal
    subtotalEl.textContent = formatMoney(cart.total_price);

    // Show/hide empty state using style instead of hidden attribute
    if (cart.items.length === 0) {
      emptyEl.style.display = 'flex';
      itemsEl.innerHTML = '';
      return;
    }

    emptyEl.style.display = 'none';

    // Render items with linked image and product title
    itemsEl.innerHTML = cart.items.map(function (item) {
      return `
        <div class="kcd-item" data-key="${item.key}">
          <a href="${item.url}" class="kcd-item__img-link">
            <img
              class="kcd-item__img"
              src="${item.image}"
              alt="${item.title}"
              loading="lazy"
              width="72"
              height="72"
            >
          </a>
          <div class="kcd-item__info">
            <a href="${item.url}" class="kcd-item__name-link">
              <p class="kcd-item__name">${item.product_title}</p>
            </a>
            <p class="kcd-item__price">${formatMoney(item.price)}</p>
            <div class="kcd-item__qty">
              <button class="kcd-item__qty-btn kcd-qty-minus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">
                <svg width="14" height="14" viewBox="0 0 256 256" fill="currentColor"><path d="M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128Z"/></svg>
              </button>
              <span class="kcd-item__qty-num">${item.quantity}</span>
              <button class="kcd-item__qty-btn kcd-qty-plus" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">
                <svg width="14" height="14" viewBox="0 0 256 256" fill="currentColor"><path d="M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z"/></svg>
              </button>
            </div>
          </div>
          <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px;flex-shrink:0;">
            <p class="kcd-item__line-total">${formatMoney(item.line_price)}</p>
            <button class="kcd-item__remove" data-key="${item.key}" aria-label="Remove item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        </div>
      `;
    }).join('');

    bindItemEvents();
  }

  /* ── Bind item events ── */
  function bindItemEvents() {
    document.querySelectorAll('.kcd-qty-minus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = this.dataset.key;
        const qty = parseInt(this.dataset.qty, 10);
        updateQty(key, Math.max(0, qty - 1));
      });
    });

    document.querySelectorAll('.kcd-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = this.dataset.key;
        const qty = parseInt(this.dataset.qty, 10);
        updateQty(key, qty + 1);
      });
    });

    document.querySelectorAll('.kcd-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateQty(this.dataset.key, 0);
      });
    });
  }

  /* ── Update quantity ── */
  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function (err) { console.error('Update qty error', err); });
  }

  /* ── Quick add ── */
  document.querySelectorAll('.kcd-upsell__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      if (!variantId || variantId === '') return;

      btn.classList.add('is-loading');
      btn.innerHTML = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          fetchCart();
          btn.classList.remove('is-loading');
          btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg> Added!`;
          setTimeout(function () {
            btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="m2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg> Quick add`;
          }, 1500);
        })
        .catch(function (err) { console.error('Quick add error', err); });
    });
  });

  /* ── Intercept fetch to detect add to cart ── */
  const originalFetch = window.fetch;
  window.fetch = function () {
    const args = arguments;
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const result = originalFetch.apply(this, args);
    if (url.includes('/cart/add')) {
      result.then(function (res) {
        if (res.ok) {
          res.clone().json().then(function () {
            openDrawer();
          }).catch(function () {});
        }
        return res;
      }).catch(function () {});
    }
    return result;
  };

  /* ── Init ── */
  function init() {
    wireCartTriggers();
    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();